// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://slverajtgzwbuekjxcni.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNsdmVyYWp0Z3p3YnVla2p4Y25pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzOTM1MjQsImV4cCI6MjA1OTk2OTUyNH0.mrZQ2L04qwQ6EjtXmHX9DYnpOIt5NH6jy-fFsQHMj8M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);